import { NavLink } from 'react-router-dom';
import { cn } from '@/shared/lib/cn';
import { absoluteAvatarUrl, UserAvatar } from '@/entities/user';
import { useAuth } from '@/shared/hooks/useAuth';
import { KnowMatchLogo } from '@/shared/ui';
import { NAV_ITEMS } from './navigation';

export const Sidebar = () => {
  const { user } = useAuth();
  // Mesma logica do AppHeader: URL absoluta + cache-bust pos upload.
  const avatar = absoluteAvatarUrl(user?.fotoUrl, user?.fotoUpdatedAt ?? null);
  return (
    <aside
      aria-label="Navegação principal"
      className="fixed inset-y-0 left-0 z-30 hidden h-screen w-64 flex-col bg-[#101828] text-white lg:flex"
    >
      <div className="flex items-center gap-3 px-6 pt-8 pb-6">
        <KnowMatchLogo className="h-8 w-auto text-white" />
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-2">
        <ul className="flex flex-col gap-1">
          {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors duration-150',
                    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white',
                    isActive
                      ? 'bg-white/10 text-white'
                      : 'text-white/70 hover:bg-white/5 hover:text-white',
                  )
                }
              >
                <Icon className="h-5 w-5" aria-hidden />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {user ? (
        <div className="flex items-center gap-3 border-t border-white/10 px-4 py-4">
          <UserAvatar nome={user.nome} fotoUrl={avatar} size="md" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-white">{user.nome}</p>
            <p className="truncate text-xs text-gray-400">{user.email}</p>
          </div>
        </div>
      ) : null}
    </aside>
  );
};
